import React from "react";
import Layout from "../../components/Layout";
import HeroSection from "../../components/HeroSection/HeroSection";
import { useTranslation } from "react-i18next";
import AboutUsTradition from "../../components/about-us/AboutUsTradition/AboutUsTradition";
import AboutUsText from "../../components/about-us/AboutUsText/AboutUsText";
import AboutUsMap from "../../components/about-us/AboutUsMap/AboutUsMap";
import { Helmet } from "react-helmet-async";

/*----- Hero Images -----*/
import heroImage1 from "../../assets/images/great-hall/greatHall6.jpg";
import heroImage2 from "../../assets/images/crystal-hall/crystalHall6.jpg";
import heroImage3 from "../../assets/images/small-hall/smallHall6.jpg";
import heroImage4 from "../../assets/images/playroom/playroom6.jpg";
import heroImage5 from "../../assets/images/catering/catering7.jpg";

export default function AboutUs() {
  const { t } = useTranslation(["about_us", "links"]);
  return (
    <Layout>
      <Helmet>
        <title>O nama</title>
        <meta
          name="description"
          content={
            "Restoran Gazimestan je od 2001. godine prerastao iz manjeg restorana od 120 mesta u moderan ugostiteljski objekat sa tri sale."
          }
        />
        <link rel="canonical" href={"https://vidovdanrestoran.rs/about-us"} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={"Mesto gde proslave postaju uspomene"}
        />
        <meta
          property="og:description"
          content={
            "Restoran Gazimestan je od 2001. godine prerastao iz manjeg restorana od 120 mesta u moderan ugostiteljski objekat sa tri sale."
          }
        />
        <meta property="og:image" content={heroImage1} />
        <meta
          property="og:url"
          content={"https://vidovdanrestoran.rs/about-us"}
        />
        <meta property="og:site_name" content="Vidovdan" />
        <meta property="og:locale" content="sr_RS" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={"Mesto gde proslave postaju uspomene"}
        />
        <meta
          name="twitter:description"
          content={
            "Restoran Gazimestan je od 2001. godine prerastao iz manjeg restorana od 120 mesta u moderan ugostiteljski objekat sa tri sale."
          }
        />
        <meta name="twitter:image" content={heroImage1} />
      </Helmet>
      <HeroSection
        title={t("about_us_hero_title")}
        subTitle={t("about_us_hero_subtitle")}
        description={t("about_us_hero_description")}
        images={[heroImage1, heroImage2, heroImage3, heroImage4, heroImage5]}
      />
      <AboutUsText t={t} />
      <AboutUsTradition t={t} />
      <AboutUsMap />
    </Layout>
  );
}
